export default __webpack_public_path__ + "static/media/tab_overview_inactive.2d1bdf0e.svg";